import { Navigate } from "react-router-dom";
import { featureFlags } from "../../config/featureFlags";

/** Audit Readiness merged into Operational Workflow (compliance-workflow). */
export default function ComplianceCenterAuditReadinessWorkspace() {
  if (featureFlags.COMPLIANCE_WORKFLOW_V1) {
    return <Navigate to="/compliance-workflow" replace />;
  }
  return <Navigate to="/compliance-center/overview" replace />;
}
